import { apiClient } from './client';
import type { ProjectOption } from '@/types/oscar';

/**
 * GET /api/project-options — the projects a hardware purchase may be charged to
 * (084, design §20).
 *
 * ⛔ THIS LIST IS NOT THE AUTHORITY. Whether a project may actually be charged
 * is the Project Tracker's question, and it is asked again when the cost line is
 * created. This exists so the fulfiller picks from real options rather than
 * typing a reference from memory.
 *
 * ⚠ AN EMPTY LIST IS SURVIVABLE AND MEANS "no choice available" — the API
 * returns one rather than a 500 when the view is missing, so the allocation
 * panel keeps working and charges the standing project, exactly as it did
 * before. Do not treat empty as an error.
 *
 * Gated on who may allocate, not on plain read.
 */
export function getProjectOptions(
  search?: string,
  signal?: AbortSignal,
): Promise<ProjectOption[]> {
  const q = search ? `?search=${encodeURIComponent(search)}` : '';
  return apiClient.get<ProjectOption[]>(`/api/project-options${q}`, signal);
}
